import React from "react";

export default function Footer() {
  return (
    <div className='footer'>
      Open-Source by{" "}
      <span>
        <a href='https://github.com/lkbobadi/Vanilla-Weather-App-React'>
          Laura Bobadilla
        </a>
      </span>
    </div>
  );
}
